import { useAuth } from "./AuthContext";

/**
 * Hook para verificar se o usuário tem uma permissão específica
 */
export const usePermission = (permission: string): boolean => {
  const { user } = useAuth();
  return user?.permissions?.includes(permission) ?? false;
};

/**
 * Hook para verificar se o usuário tem pelo menos uma das permissões
 */
export const useAnyPermission = (permissions: string[]): boolean => {
  const { user } = useAuth();
  return permissions.some(permission => user?.permissions?.includes(permission)) ?? false;
};

/**
 * Hook para verificar se o usuário tem todas as permissões
 */
export const useAllPermissions = (permissions: string[]): boolean => {
  const { user } = useAuth();
  return permissions.every(permission => user?.permissions?.includes(permission)) ?? false;
};
